module.exports = __webpack_public_path__ + "static/media/resolvedcheck.02eda384.svg";